export default "__VITE_ASSET__CjEXUdDh__"